export default "__VITE_ASSET__221caee6__"